import React from 'react';
import { Link } from 'react-router-dom';
import {
  CpuChipIcon,
  ChartBarIcon,
  CloudArrowUpIcon,
  BoltIcon,
  ShieldCheckIcon,
  ArrowTrendingUpIcon
} from '@heroicons/react/24/outline';

export default function Landing() {
  const features = [
    {
      icon: CpuChipIcon,
      title: 'Financial Automation',
      description: 'Automate accounting operations and streamline financial workflows for Alternative Investment Funds.'
    },
    {
      icon: ChartBarIcon,
      title: 'AIF Control & Management',
      description: 'Tools for controlling and managing Alternative Investment Funds with precision and compliance.'
    },
    {
      icon: CloudArrowUpIcon,
      title: 'DATEV Integration',
      description: 'Integrate with DATEV for document upload and accounting workflow management.'
    },
    {
      icon: BoltIcon,
      title: 'Real-time Processing',
      description: 'Process documents and manage jobs in real-time with automated status tracking and monitoring.'
    },
    {
      icon: ShieldCheckIcon,
      title: 'Security & Compliance',
      description: 'Secure financial data handling with encryption and compliance frameworks.'
    },
    {
      icon: ArrowTrendingUpIcon,
      title: 'Analytics & Insights',
      description: 'Track and analyze accounting operations with detailed logs and status monitoring.'
    }
  ];

  return (
    <div className="landing-page">
      {/* Header Section */}
      <header className="landing-header">
        <div className="landing-header-content">
          <h1 className="landing-title">Admintools</h1>
          <p className="landing-subtitle">
            Accounting automation and management solutions for Alternative Investment Funds. Integrate with DATEV to streamline your financial operations.
          </p>
          <div className="landing-cta">
            <Link className="btn-primary-large" to="/login">Get Started</Link>
          </div>
        </div>
      </header>

      {/* Hero Image Section */}
      <section className="landing-hero-image">
        <div className="landing-container">
          <img src="/img1.jpg" alt="Financial Solutions" className="hero-image" />
        </div>
      </section>

      {/* Features Section */}
      <section className="landing-features">
        <div className="landing-container">
          <h2 className="section-title">Features</h2>
          <div className="features-grid">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={index} className="feature-card">
                  <div className="feature-icon">
                    <IconComponent className="w-12 h-12" />
                  </div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-container">
          <p className="footer-text">
            © 2025 Admintools. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

